
function updateSlideArriaHidden(slide, slider){
  slide.removeAttribute('aria-hidden');
}

function updateSlider(slider, slideQuery) {
  slider.querySelectorAll(slideQuery).forEach( (slide)=>{
    updateSlideArriaHidden(slide, slider);
  });
}

function init(sliderQuery, slideQuery) {
  allSliders = Array.from(document.querySelectorAll(sliderQuery));
  if(allSliders.length){
    arrayIntersectionObserver = [];
    
    allSliders.forEach( (slider)=>{
      slider.querySelectorAll( slideQuery ).forEach( (slide)=>{
        const observer = new IntersectionObserver(
          entries => {
            updateSlider(slider, slideQuery);
          }
        );
        observer.observe(slide);
        arrayIntersectionObserver.push(observer);

        updateSlideArriaHidden(slide, slider);
      });
    })
  }
}

window.onload = (event) =>{
  init('.flickity-viewport', '.carousel__slide' );
};